<div class="modal-header">
  <h4 class="modal-title">
    [{{ designCard.id }}] {{ designCard.design_name }}
    <span
      class="due-badge"
      *ngIf="
        design &&
        design.id &&
        !design.mark_as_completed &&
        design.project_type &&
        design.project_type_id
      "
    >
      <i class="fa fa-clock"></i>
      <ng-container *ngIf="calculateDueDays() < 0">
        Due {{ calculateDueDays() * -1 }} days ago
      </ng-container>
      <ng-container *ngIf="calculateDueDays() === 1"> Due tomorrow </ng-container>
      <ng-container *ngIf="calculateDueDays() > 1">
        Due in {{ calculateDueDays() }} days
      </ng-container>
      <ng-container *ngIf="calculateDueDays() === 0"> Due today </ng-container>
    </span>
  </h4>

  <div>
    <div
      ngbDropdown
      class="d-inline-block action-right"
      container="body"
      placement="bottom-right"
    >
      <button
        ngbDropdownToggle
        mat-mini-fab
        type="button"
        color="default"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="flaticon-more-1"></i>
      </button>
      <div ngbDropdownMenu aria-labelledby="action-button">
        <button ngbDropdownItem class="btn" (click)="editdesign()">
          <i class="fas fa-edit"></i> Edit
        </button>
        <button ngbDropdownItem class="btn" (click)="deletedesign()">
          <i class="fas fa-trash text-danger"></i> Delete
        </button>
        <!-- <button ngbDropdownItem class="btn" (click)="createAsSku()" *ngIf="!designCard.is_quotation"><i class="fas fa-inbox"></i> Convert to RFQ</button> -->
        <button
          ngbDropdownItem
          class="btn"
          (click)="convertToRFQ()"
          *ngIf="!designCard.is_quotation"
        >
          <i class="fas fa-edit"></i> Convert to RFQ
        </button>
        <button
          ngbDropdownItem
          class="btn"
          (click)="convertToInventory()"
          *ngIf="designCard.is_quotation"
        >
          <i class="fas fa-edit"></i> Convert to Inventory SKU
        </button>

        <button ngbDropdownItem type="button" (click)="closeModal()">
          <i class="fas fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>

  <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('')">
		<div aria-hidden="true">&times;</span>
	</button> -->
</div>
<div class="modal-body">
  <div class="loading" *ngIf="!design || !design.id">
    <h5 class="text-center">
      <i class="fas fa-spinner fa-spin"></i> Getting details
    </h5>
  </div>
  <!-- <div class="actions">
		<button class="btn" type="button" (click)="editdesign()"><i class="fas fa-edit"></i> Edit</button>
		<button class="btn" type="button" (click)="deletedesign()"><i class="fas fa-trash text-danger"></i> Delete</button>
		<button class="btn" type="button" (click)="createAsSku()" *ngIf="design && !design.is_quotation"><i class="fas fa-edit"></i> Convert to RFQ</button>
	</div>
	<div ngbDropdown class="d-inline-block" container="body" placement="bottom-right">
		<button ngbDropdownToggle mat-mini-fab type="button" color="default" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			<i class="flaticon-more-1"></i>
		</button>
		<div ngbDropdownMenu aria-labelledby="action-button">
			<button ngbDropdownItem class="btn" (click)="editdesign()"><i class="fas fa-edit"></i> Edit</button>
			<button ngbDropdownItem class="btn" (click)="deletedesign()"><i class="fas fa-trash text-danger"></i> Delete</button>
			<button ngbDropdownItem class="btn" (click)="createAsSku()" *ngIf="!design.is_quotation"><i class="fas fa-edit"></i> Convert to RFQ</button>
		</div>
	</div> -->

  <ng-container *ngIf="design && design.id">
    <mat-tab-group dynamicHeight [(selectedIndex)]="tabIndex">
      <!-- <mat-tab label="Channel Details"> dsf </mat-tab> -->
      <mat-tab>
        <ng-template mat-tab-label> General </ng-template>
        <div
          class="pb-3"
          *ngIf="
            design.description ||
            (design.additional_descriptions &&
              design.additional_descriptions.length > 0)
          "
        >
          <mat-tab-group
            class="description-tabs"
            [(selectedIndex)]="activeDescriptionTab"
          >
            <mat-tab *ngIf="design.description && design.description != ''">
              <ng-template mat-tab-label> Description </ng-template>
              <div class="form-group">
                <span class="value" [innerHTML]="design.description"></span>
              </div>
            </mat-tab>
            <mat-tab
              *ngFor="
                let description of design.additional_descriptions;
                let i = index
              "
            >
              <ng-template mat-tab-label>
                {{ description.title }}
              </ng-template>
              <div class="form-group">
                <span
                  class="value"
                  *ngIf="description.text"
                  [innerHTML]="description.text"
                ></span>
                <span class="value" *ngIf="!description.text"
                  ><i>No description.</i></span
                >
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-8">
            <div class="form-group">
              <small class="label">Task Name</small>
              <span class="value">{{ design.design_name }}</span>
            </div>
            <!-- <div class="form-group" *ngIf="design.design_priority != null">
                    <small class="label">Priority</small>
                    <span class="value">{{ priority[design.design_priority] }}</span>
                </div> -->

            <div
              class="form-group"
              *ngIf="design.assigned_users && design.assigned_users.length > 0"
            >
              <small class="label">Assignee/s</small>
              <ul>
                <span *ngFor="let u of design.assigned_users">
                  <span *ngIf="u.user != null">
                    <li class="value">
                      {{ u.user.firstname + ' ' + u.user.lastname }}
                    </li>
                  </span>
                </span>
              </ul>
            </div>
          </div>
          <div class="col-lg-6 col-md-4">
            <div class="form-group" *ngIf="design.id">
              <small class="label">Reference ID</small>
              <span class="value">{{ design.id }}</span>
            </div>
            <div class="form-group" *ngIf="design.due_date != null">
              <small class="label">Due Date</small>
              <span class="value">{{ design.due_date | date: 'mediumDate' }}</span>
            </div>
            <div class="form-group" *ngIf="design.created_at != null">
              <small class="label">Date Created</small>
              <span class="value">{{
                design.created_at | date: 'mediumDate'
              }}</span>
            </div>
            <div class="form-group" *ngIf="design.created_by">
              <small class="label">Created By</small>
              <span class="value">{{
                design.created_by.firstname + ' ' + design.created_by.lastname
              }}</span>
            </div>
            <div class="form-group" *ngIf="design.category">
              <small class="label">Category</small>
              <span class="value">{{ design.category.product_category }}</span>
            </div>
            <div class="form-group" *ngIf="design.subcategory">
              <small class="label">Subcategory</small>
              <span class="value">{{ design.subcategory.sub_category }}</span>
            </div>
          </div>
        </div>

        <div
          class="row"
          class="row"
          *ngIf="design.assigned_tags && design.assigned_tags.length > 0"
        >
          <div class="col-md-12">
            <hr />
            <div class="form-group">
              <h5 class="label">Tag/s</h5>
              <div *ngFor="let tag of mappedTags; let i = index" class="child">
                <span class="label">{{ tag.name }}</span>
                <div *ngIf="tag.children && tag.children.length > 0">
                  <ng-container
                    *ngTemplateOutlet="
                      tagList;
                      context: {
                        tags: tag.children,
                      }
                    "
                  >
                  </ng-container>
                </div>
              </div>

              <!-- <span *ngFor="let mt of mappedTags; let i = index">
								<small class="label" *ngIf="mt[0]">{{ mt[0] }}</small>
								<ul class="tags-list" *ngIf="mt[1]">
									<li>{{ mt[1] }}</li>
									<li>
										<ul *ngIf="mt[2]">
											<li>{{ mt[2] }}</li>
											<li>
												<ul *ngIf="mt[3]">
													<li>{{ mt[3] }}</li>
												</ul>
											</li>
										</ul>
									</li>
								</ul>
							</span> -->
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-12">
            <div class="form-group" *ngIf="design.links && design.links.length > 0">
              <div class="label">
                Links (<a class="link" (click)="showLinks = !showLinks">{{
                  showLinks ? '-' : '+'
                }}</a
                >)
              </div>
              <span class="value">
                <a href="{{ design.links[0] }}" target="_blank">
                  {{ design.links[0] }}
                </a>
              </span>
              <ng-container *ngIf="design.links.length > 1">
                <ng-container *ngIf="showLinks">
                  <span class="value" *ngFor="let link of design.links | slice: 1">
                    <a href="{{ link }}" target="_blank">
                      {{ link }}
                    </a>
                  </span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div
              class="form-group"
              *ngIf="design.attachments && design.attachments.length > 0"
            >
              <div class="label">Attachment/s</div>
              <ul class="list-group" *ngFor="let u of design.attachments">
                <li
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <i class="fa fa-file text-info mr-4 fa-2x"></i>{{ u.name }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-info">
                      <!-- <button (click)="viewAttachment(u)" class="btn btn-sm btn-link"><i class="fas fa-eye"></i></button> -->
                      <a
                        href="javascript:;"
                        class="px-1"
                        (click)="viewAttachment(u)"
                        title="View file"
                        ><i class="fas fa-eye"></i
                      ></a>
                      <a (click)="downloadAttachment(u)" class="px-1"
                        ><i class="fas fa-download"></i
                      ></a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          Notes/Comments ({{ design.assigned_comments_count }})
        </ng-template>
        <div class="row">
          <div class="col-md-12">
            <cnc-nd-card-notes
              *ngIf="design && design.id"
              [design]="design"
            ></cnc-nd-card-notes>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          Sub Tasks ({{ design.assigned_subtasks_count }})
        </ng-template>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <cnc-nd-card-subtasks
              *ngIf="design && design.id"
              [design]="design"
              [highlightSubtaskId]="highlightSubtaskId"
              [eventsSaveTemplate]="saveTemplateEventSubject.asObservable()"
              [eventsOverwriteTemplate]="
                overwriteTemplateEventSubject.asObservable()
              "
            ></cnc-nd-card-subtasks>
            <!-- <div class="d-flex flex-column comment-section">
							<h6>Subtasks</h6>
							<div class="row">
								<div class="col-md-12">
									<ul class="list-group">
										<li class="list-group-item" *ngFor="let u of design.assigned_subtasks; let i = index">
											<div class="form-check">
												<input [(ngModel)]="u.done" class="form-check-input checkbox-1x" type="checkbox" [checked]="u.done" (change)="toggleCheckbox(i, $event)" [id]="u.id" />
												<div class="ml-4 mb-3 clickable" *ngIf="!u.editable" (click)="editSubtaskItem(i)">
													<del *ngIf="u.done">{{ u.text }}</del>
													<span *ngIf="!u.done">{{ u.text }}</span
													><br />
													<span
														><small
															>Added By: <strong>{{ u?.user?.firstname + " " + u?.user?.lastname }}</strong></small
														></span
													>
												</div>
												<div class="ml-4 mb-3" *ngIf="u.editable">
													<textarea class="form-control" name="text" [(ngModel)]="u.text"></textarea>
													<div class="btn-group mt-1">
														<button (click)="saveSubtaskItem(i)" class="btn btn-xs btn-primary">Save</button>
														<button (click)="cancelSubtaskItem()" class="btn btn-xs btn-outline-secondary">Cancel</button>
													</div>
													<button (click)="deleteSubtaskItem(i)" class="btn btn-xs btn-link"><i class="text-danger fas fa-times"></i></button>
												</div>
											</div>
										</li>
									</ul>
									<button (click)="addSubtaskItem()" class="btn btn-sm btn-primary mb-3 float-right">Add Sub Task</button>
								</div>
							</div>
						</div> -->
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          Resources ({{ design.linked_resources_count }})
        </ng-template>
        <mat-tab-group *ngIf="tabIndex == 3" [selectedIndex]="0">
          <ng-container *ngIf="design.is_quotation">
            <mat-tab *ngIf="design.rfq">
              <ng-template mat-tab-label> Quotation </ng-template>

              <cnc-rfq-details-quotations
                [rfq]="design.rfq"
                (onSubmitQuotation)="updateQuotation($event)"
                [isQuotationRfq]="true"
              ></cnc-rfq-details-quotations>
            </mat-tab>
          </ng-container>
          <ng-container *ngIf="!design.is_quotation">
            <mat-tab>
              <ng-template mat-tab-label>
                SKU ({{ design.linked_rfqs.length }})
              </ng-template>
              <div class="d-flex flex-row-reverse">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  (click)="createRfq()"
                >
                  Add New SKU
                </button>
              </div>
              <div class="form-group col-12 px-0">
                <label for="">Search</label>
                <div class="input-group">
                  <cnc-sku-kit-dropdown
                    class="flex-fill col-11 pl-0"
                    (selectedItem)="getSelectedSKUItem($event)"
                    [isRfqs]="true"
                  ></cnc-sku-kit-dropdown>
                  <div class="input-group-append col-1">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="addToModule('rfqs')"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="overflow-auto">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Remarks</th>
                      <th width="50px">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngIf="!design.linked_rfqs || design.linked_rfqs.length == 0"
                    >
                      <td colspan="9" class="text-center">
                        <br />
                        <h6 class="text-warning">No record found.</h6>
                        <br />
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="design.linked_rfqs && design.linked_rfqs.length > 0"
                    >
                      <tr
                        *ngFor="let r of design.linked_rfqs; let i = index"
                        class="link"
                      >
                        <td
                          (click)="router.navigate(['inventory/' + r.id + '/view'])"
                        >
                          {{ r.internal_sku ? r.internal_sku : r.sku }}
                        </td>
                        <td
                          (click)="router.navigate(['inventory/' + r.id + '/view'])"
                        >
                          {{ r.product_name }}
                        </td>
                        <td>{{ r.pivot.remarks }}</td>
                        <td>
                          <div
                            ngbDropdown
                            class="d-inline-block"
                            container="body"
                            placement="bottom-right"
                          >
                            <button
                              ngbDropdownToggle
                              class="btn btn-sm"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="action-button">
                              <button ngbDropdownItem (click)="createRfq(r, i)">
                                <i class="fas fa-edit"></i>
                                Edit
                              </button>
                              <button
                                ngbDropdownItem
                                (click)="removeFromModule('rfqs', i)"
                              >
                                <i class="fas fa-trash text-danger"></i> Remove
                              </button>
                              <button
                                ngbDropdownItem
                                *ngIf="r.product_type_id != 2"
                                (click)="updateSku(r, i)"
                              >
                                <i class="fas fa-edit"></i> Set as Inventory SKU
                              </button>
                              <button
                                ngbDropdownItem
                                *ngIf="r.product_type_id == 2"
                                class="text-danger"
                              >
                                <i class="fa fa-exclamation text-danger"></i>
                                Already an Inventory SKU
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                CLIENTS ({{ design.linked_clients.length }})
              </ng-template>
              <div class="d-flex flex-row-reverse">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  (click)="createClient()"
                >
                  Add New Client
                </button>
              </div>
              <div class="form-group col-12 px-0">
                <label for="">Search clients</label>
                <div class="input-group">
                  <ng-select
                    [items]="client$ | async"
                    [addTag]="false"
                    [multiple]="false"
                    [hideSelected]="true"
                    [trackByFn]="trackClientByFn"
                    [loading]="clientLoading"
                    [typeahead]="clientInput$"
                    [(ngModel)]="selected.clients"
                    class="flex-fill col-11 pl-0"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span
                        class="ng-value-icon right"
                        (click)="clear(item)"
                        aria-hidden="true"
                        >×</span
                      >
                      <span>
                        {{ item.business_name }}
                        <small *ngIf="item.user">
                          {{ item.user.firstname }} {{ item.user.lastname }}
                        </small>
                      </span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <h6>
                        {{ item.business_name }}
                        <small *ngIf="item.user">
                          {{ item.user.firstname }} {{ item.user.lastname }}
                        </small>
                      </h6>
                    </ng-template>
                  </ng-select>
                  <div class="input-group-append col-1">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="addToModule('clients')"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="overflow-auto">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="link" [translate]="'CLIENTS.BUSINESS_NAME'">
                        {{ 'ACCOUNT.BUSINESS_NAME' | translate }}
                      </th>
                      <th class="link" [translate]="'CLIENTS.USER_ACCOUNT'">
                        Contact Name
                      </th>
                      <th class="link" [translate]="'CLIENTS.BUSINESS_ADDRESS'">
                        Business Address
                      </th>
                      <th class="link" [translate]="'CLIENTS.PHONE'">Phone</th>
                      <th [translate]="'TITLES.STATUS'" class="text-center">
                        Status
                      </th>
                      <th>Remarks</th>
                      <th width="50px">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngIf="
                        !design.linked_clients || design.linked_clients.length == 0
                      "
                    >
                      <td colspan="9" class="text-center">
                        <br />
                        <h6 class="text-warning">No record found.</h6>
                        <br />
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="
                        design.linked_clients && design.linked_clients.length > 0
                      "
                    >
                      <tr
                        *ngFor="let r of design.linked_clients; let i = index"
                        class="link"
                      >
                        <td>
                          <span class="mr-2 text-info">{{ r.business_name }}</span>
                          <small>{{ r.business_type }}</small>
                        </td>
                        <td
                          (click)="
                            router.navigate(['clients/' + r.id + '/profile'])
                          "
                          class="text-capitalize text-info"
                        >
                          <span *ngIf="r.user">
                            {{ r.user.firstname + ' ' + r.user.lastname }}
                          </span>
                        </td>
                        <td>{{ r.business_address }}</td>
                        <td>{{ r.phone }}</td>
                        <td class="text-center">
                          <span *ngIf="r.status == 1" class="badge badge-success"
                            >Active</span
                          >
                          <span *ngIf="r.status == 0" class="badge badge-danger"
                            >In-active</span
                          >
                        </td>
                        <td>{{ r.pivot.remarks }}</td>
                        <td>
                          <div
                            ngbDropdown
                            class="d-inline-block"
                            container="body"
                            placement="bottom-right"
                          >
                            <button
                              ngbDropdownToggle
                              class="btn btn-sm"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="action-button">
                              <button
                                ngbDropdownItem
                                (click)="removeFromModule('clients', i)"
                              >
                                <i class="fas fa-trash text-danger"></i> Remove
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                CLIENT USERS ({{ design.linked_client_users.length }})
              </ng-template>
              <div class="d-flex flex-row-reverse">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  (click)="createClientUser()"
                >
                  Add New Client User
                </button>
              </div>
              <div class="form-group col-12 px-0">
                <label for="">Search client users</label>
                <div class="input-group">
                  <ng-select
                    [items]="clientUser$ | async"
                    [addTag]="false"
                    [multiple]="false"
                    [hideSelected]="true"
                    [trackByFn]="trackClientUserByFn"
                    [loading]="clientUserLoading"
                    [typeahead]="clientUserInput$"
                    [(ngModel)]="selected.client_users"
                    class="flex-fill col-11 pl-0"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span
                        class="ng-value-icon right"
                        (click)="clear(item)"
                        aria-hidden="true"
                        >×</span
                      >
                      <span>
                        [{{ item.email }}]
                        <small> {{ item.firstname }} {{ item.lastname }} </small>
                      </span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <h6>
                        [{{ item.email }}]
                        <small> {{ item.firstname }} {{ item.lastname }} </small>
                      </h6>
                    </ng-template>
                  </ng-select>
                  <div class="input-group-append col-1">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="addToModule('client_users')"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="overflow-auto">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Firstname</th>
                      <th>Lastname</th>
                      <th>Remarks</th>
                      <th width="50px">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngIf="
                        !design.linked_client_users ||
                        design.linked_client_users.length == 0
                      "
                    >
                      <td colspan="9" class="text-center">
                        <br />
                        <h6 class="text-warning">No record found.</h6>
                        <br />
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="
                        design.linked_client_users &&
                        design.linked_client_users.length > 0
                      "
                    >
                      <tr
                        *ngFor="let r of design.linked_client_users; let i = index"
                        class="link"
                      >
                        <td>{{ r.email }}</td>
                        <td>{{ r.firstname }}</td>
                        <td>{{ r.lastname }}</td>
                        <td>{{ r.pivot.remarks }}</td>
                        <td>
                          <div
                            ngbDropdown
                            class="d-inline-block"
                            container="body"
                            placement="bottom-right"
                          >
                            <button
                              ngbDropdownToggle
                              class="btn btn-sm"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="action-button">
                              <button
                                ngbDropdownItem
                                (click)="removeFromModule('client_users', i)"
                              >
                                <i class="fas fa-trash text-danger"></i> Remove
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                PO ({{ design.linked_purchase_orders.length }})
              </ng-template>
              <div class="d-flex flex-row-reverse">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  (click)="createPurchaseOrder()"
                >
                  Add New PO
                </button>
              </div>
              <div class="form-group col-12 px-0">
                <label for="">Search</label>
                <div class="input-group">
                  <ng-select
                    [items]="purchaseOrder$ | async"
                    [addTag]="false"
                    [multiple]="false"
                    class="flex-fill col-11 pl-0"
                    [hideSelected]="true"
                    [trackByFn]="trackByFn"
                    [loading]="purchaseOrderLoading"
                    [typeahead]="purchaseOrderInput$"
                    [(ngModel)]="selected.purchase_orders"
                    name="rfqProduct"
                    appendTo="body"
                    required
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.id | purchaseOrderFormat }}
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      {{ item.id | purchaseOrderFormat }}
                    </ng-template>
                  </ng-select>
                  <div class="input-group-append col-1">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="addToModule('purchase_orders')"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="overflow-auto">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th width="130" class="link">Order Date</th>
                      <th class="link">Factory</th>
                      <th class="link">Estimated Arrival</th>
                      <th class="link text-right" [translate]="'TITLES.TOTAL_COST'">
                        Total Cost
                      </th>
                      <th class="link text-right" [translate]="'TITLES.TOTAL_PAID'">
                        Total Paid
                      </th>
                      <th class="link text-right">Payment Terms</th>
                      <th>Order Status</th>
                      <th>Remarks</th>
                      <th width="50px">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngIf="
                        !design.linked_purchase_orders ||
                        design.linked_purchase_orders.length == 0
                      "
                    >
                      <td colspan="7" class="text-center">
                        <br />
                        <h6 class="text-warning">No record found.</h6>
                        <br />
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="
                        design.linked_purchase_orders &&
                        design.linked_purchase_orders.length > 0
                      "
                    >
                      <tr
                        *ngFor="
                          let r of design.linked_purchase_orders;
                          let i = index
                        "
                        [ngClass]="{
                          'partial-received':
                            r.total_received_rfqs && r.order_status_id < 99,
                        }"
                      >
                        <td>
                          {{ r.order_date | date: 'mediumDate' }} <br />
                          <b>
                            {{ r.id | purchaseOrderFormat }}
                          </b>
                        </td>

                        <td class="text-capitalize">
                          <a
                            [routerLink]="['/orders', r.id]"
                            routerLinkActive="po-link-active"
                          >
                            {{ r.factory.factory_name }}
                          </a>
                        </td>

                        <td>
                          {{ r.arrival_due_date | date: 'mediumDate' }} <br />
                          <b>{{ r.logistic_label }}</b>
                        </td>

                        <td class="text-right">
                          <span *ngIf="authService.loginUser.prwx == 7">
                            &#64;
                            <b>{{
                              r.total_cost + r.total_shipping_cost | currency: ''
                            }}</b>
                            <div
                              class="shipping text-warning"
                              *ngIf="
                                r.total_shipping_cost_amount &&
                                r.total_shipping_cost_amount.cost_amount
                              "
                            >
                              <i class="fas fa-shipping-fast"></i
                              >{{
                                r.total_shipping_cost_amount.cost_amount
                                  | currency: ''
                              }}
                            </div>
                          </span>
                        </td>

                        <td class="text-right">
                          <span *ngIf="authService.loginUser.prwx == 7">
                            <span *ngIf="r.total_paid > 0" class="text-info">
                              {{ r.total_paid | currency: '' }}
                            </span>
                            <span *ngIf="r.total_paid <= 0" class="text-danger">
                              {{ 0 | currency: '' }}
                            </span>
                            <br />
                          </span>

                          <span
                            *ngIf="r.total_paid > 0 && r.total_paid < r.total_cost"
                            class="mb-1 kt-badge kt-badge--warning kt-badge--inline kt-badge--pill"
                          >
                            Partially Paid
                          </span>
                          <span
                            *ngIf="r.total_paid >= r.total_cost"
                            class="mb-1 kt-badge kt-badge--success kt-badge--inline kt-badge--pill"
                          >
                            Fully Paid
                          </span>
                          <span
                            *ngIf="r.total_paid <= 0"
                            class="mb-1 kt-badge kt-badge--info kt-badge--inline kt-badge--pill"
                          >
                            Awaiting Payment
                          </span>
                        </td>

                        <td>
                          {{ r.payment_terms }}
                          <div
                            *ngIf="
                              r.due_amount > 0 && authService.loginUser.prwx == 7
                            "
                            class="due"
                          >
                            [<b>{{ r.due_amount | currency: '' }}</b> due on
                            {{ r.due_date | date: 'mediumDate' }}]
                          </div>
                        </td>

                        <td>
                          <span class="text-success text-capitalize">
                            <i class="fas fa-check"></i>
                            {{ r.order_status_text }}
                          </span>
                          <br />
                          [{{ r.order_status_date | date: 'medium' }}]
                          <div *ngIf="r.transitStatus && r.transitStatus.json">
                            <div>
                              Tracking:
                              <b>{{ r.transitStatus.json.tracking }}</b>
                            </div>
                            <div
                              *ngIf="
                                r.transitStatus.json.vessel &&
                                r.transitStatus.json.vessel != ''
                              "
                            >
                              Vessel:
                              <b>{{ r.transitStatus.json.vessel }}</b>
                            </div>
                          </div>
                        </td>
                        <td>{{ r.pivot.remarks }}</td>
                        <td>
                          <div
                            ngbDropdown
                            class="d-inline-block"
                            container="body"
                            placement="bottom-right"
                          >
                            <button
                              ngbDropdownToggle
                              class="btn btn-sm"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="action-button">
                              <button
                                ngbDropdownItem
                                (click)="removeFromModule('purchase_orders', i)"
                              >
                                <i class="fas fa-trash text-danger"></i> Remove
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                {{ 'TITLES.CLIENT_PURCHASE_ORDERS' | translate }} ({{
                  design.linked_client_purchase_orders.length
                }})
              </ng-template>
              <div class="d-flex flex-row-reverse">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  (click)="createClientPO()"
                  [translate]="'BUTTONS.NEW_CLIENT_PURCHASE_ORDER'"
                >
                  Add New B2B Client PO
                </button>
              </div>
              <div class="form-group col-12 px-0">
                <label for="">Search</label>
                <div class="input-group">
                  <ng-select
                    [items]="clientPo$ | async"
                    [addTag]="false"
                    [multiple]="false"
                    class="flex-fill col-11 pl-0"
                    [hideSelected]="true"
                    [trackByFn]="trackByFn"
                    [loading]="clientPoLoading"
                    [typeahead]="clientPoInput$"
                    [(ngModel)]="selected.client_purchase_orders"
                    name="rfqProduct"
                    appendTo="body"
                    required
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.id | purchaseOrderFormat }}
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      {{ item.id | purchaseOrderFormat }}
                    </ng-template>
                  </ng-select>
                  <div class="input-group-append col-1">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="addToModule('client_purchase_orders')"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="overflow-auto">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>
                        {{ 'LABELS.CLIENT_PURCHASE_ORDER_ID' | translate }}
                      </th>
                      <th>
                        {{ 'LABELS.CLIENT_PURCHASE_ORDER_DATE' | translate }}
                      </th>
                      <th>Shipping Address</th>
                      <th>Remarks</th>
                      <th width="50px">&nbsp;</th>
                      <!-- <th>Items</th>
                                        <th>Gross Total</th>
                                        <th>Discount/Markup Amount</th>
                                        <th>Net Total</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngIf="
                        !design.linked_client_purchase_orders ||
                        design.linked_client_purchase_orders.length == 0
                      "
                    >
                      <td colspan="6" class="text-center">
                        <br />
                        <h6 class="text-warning">No record found.</h6>
                        <br />
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="
                        design.linked_client_purchase_orders &&
                        design.linked_client_purchase_orders.length > 0
                      "
                    >
                      <tr
                        *ngFor="
                          let r of design.linked_client_purchase_orders;
                          let i = index
                        "
                      >
                        <td>{{ r.id }}</td>
                        <td>{{ r.order_date | date: 'mediumDate' }}</td>
                        <td>
                          {{
                            [
                              r.ship_address,
                              r.ship_city,
                              r.ship_state,
                              r.ship_country,
                              r.ship_zip,
                            ].join(', ')
                          }}
                        </td>
                        <td>{{ r.pivot.remarks }}</td>
                        <td>
                          <div
                            ngbDropdown
                            class="d-inline-block"
                            container="body"
                            placement="bottom-right"
                          >
                            <button
                              ngbDropdownToggle
                              class="btn btn-sm"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="action-button">
                              <button
                                ngbDropdownItem
                                (click)="
                                  removeFromModule('client_purchase_orders', i)
                                "
                              >
                                <i class="fas fa-trash text-danger"></i> Remove
                              </button>
                            </div>
                          </div>
                        </td>
                        <!-- <td>
                                                <div class="kit-items">
                                                    <span *ngFor="let item of r.line_items"
                                                        class="kt-badge kt-badge--default kt-badge-sm kt-badge--outline kt-badge--pill">
                                                        [{{item.sku}}] {{item.product_name}} x<b>{{item.quantity}}</b>
                                                    </span>
                                                </div>
                                            </td> -->
                        <!-- <td>
                                                {{r.total_amount | currency:''}}
                                            </td>
                                            <td>
                                                {{r.discount_amount | currency:''}}
                                            </td>
                                            <td>
                                                {{r.total_amount - r.discount_amount | currency:''}}
                                            </td> -->
                      </tr>

                      <tr></tr
                    ></ng-container>
                  </tbody>
                </table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                Factories ({{ design.linked_factories.length }})
              </ng-template>
              <div class="d-flex flex-row-reverse">
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  (click)="createFactory()"
                >
                  Add New Factory
                </button>
              </div>
              <div class="form-group col-12 px-0">
                <label for="">Search</label>
                <div class="input-group">
                  <ng-select
                    [items]="factory$ | async"
                    [addTag]="false"
                    [multiple]="false"
                    class="flex-fill col-11 pl-0"
                    [hideSelected]="true"
                    [trackByFn]="trackByFn"
                    [loading]="factoryLoading"
                    [typeahead]="factoryInput$"
                    [(ngModel)]="selected.factories"
                    name="rfqProduct"
                    appendTo="body"
                    required
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.factory_name }}
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      {{ item.factory_name }}
                    </ng-template>
                  </ng-select>
                  <div class="input-group-append col-1">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="addToModule('factories')"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="overflow-auto">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Factory Name</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th width="50px">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngIf="
                        !design.linked_factories ||
                        design.linked_factories.length == 0
                      "
                    >
                      <td colspan="6" class="text-center">
                        <br />
                        <h6 class="text-warning">No record found.</h6>
                        <br />
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="
                        design.linked_factories &&
                        design.linked_factories.length > 0
                      "
                    >
                      <tr *ngFor="let r of design.linked_factories; let i = index">
                        <td>{{ r.factory_name }}</td>
                        <td>{{ r.factory_description }}</td>
                        <td>{{ r.pivot.remarks }}</td>
                        <td>
                          <div
                            ngbDropdown
                            class="d-inline-block"
                            container="body"
                            placement="bottom-right"
                          >
                            <button
                              ngbDropdownToggle
                              class="btn btn-sm"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="action-button">
                              <button
                                ngbDropdownItem
                                (click)="removeFromModule('factories', i)"
                              >
                                <i class="fas fa-trash text-danger"></i> Remove
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr></tr
                    ></ng-container>
                  </tbody>
                </table>
              </div>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </mat-tab>

      <mat-tab *ngIf="staticTags && staticTags.length > 0">
        <ng-template mat-tab-label> Static Tags </ng-template>

        <div class="row" class="row">
          <div class="col-md-12">
            <!-- <hr />
						<h6 class="label">Static Tags</h6> -->
            <div class="form-group">
              <div *ngFor="let tag of staticTags; let i = index" class="child">
                <span class="label">{{ tag.name }}</span>
                <div *ngIf="tag.children && tag.children.length > 0">
                  <ng-container
                    *ngTemplateOutlet="
                      tagList;
                      context: {
                        tags: tag.children,
                      }
                    "
                  >
                  </ng-container>
                </div>

                <!-- <ul class="children">
									<li *ngFor="let c of tag.children" class="mr-2">
										<b>{{ c.name }}</b>
									</li>
								</ul> -->
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
<div class="modal-footer">
  <div class="mr-auto">
    <button
      *ngIf="tabIndex == 2"
      type="button"
      class="btn btn-outline-info save-template-btn mr-1"
      (click)="emitSaveTemplateEvent()"
    >
      <i class="fas fa-save"></i> Save as Template
    </button>
    <button
      *ngIf="tabIndex == 2"
      type="button"
      class="btn btn-outline-success save-template-btn"
      (click)="emitOverwriteTemplateEvent()"
    >
      <i class="fas fa-pencil-alt"></i> Overwrite Template
    </button>
  </div>

  <button type="button" class="btn btn-default" (click)="closeModal()">
    <i class="fas fa-times"></i> Close
  </button>
</div>

<ng-template let-tags="tags" #tagList>
  <ul class="children">
    <li *ngFor="let tag of tags" class="mr-2">
      <b>{{ tag.name }}</b>
      <div *ngIf="tag.children && tag.children.length > 0">
        <ng-container
          *ngTemplateOutlet="
            tagList;
            context: {
              tags: tag.children,
            }
          "
        >
        </ng-container>
      </div>
    </li>
  </ul>
</ng-template>
